import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import "./Banner.css";

export default function Banner({ data }) {
  const { banner } = data;
  const domain = process.env.REACT_APP_DOMAIN || "swmc";
  const domainData = banner[domain];

  return (
    <section className="trademarks-banner">
      <Container>
        <Row className="justify-content-center text-center">
          <Col xs={12}>
            <h1 className="trademark-heading">{banner.heading}</h1>
            <h2 className="trademark-subheading">{htmlParser(domainData.subheading)}</h2>
          </Col>
        </Row>
      </Container>
    </section>
  );
}